import React from 'react'
import { FeaturedLayout } from '../../layouts'
import PlanesTab from './PlanesTab'
import { useTemporadaActiva } from './useTemporadaActiva'
import TemporadaSelector from './TemporadaSelector'

const PagosPlanes = () => {
  const { temporadaId, temporadas, setTemporadaId } = useTemporadaActiva()

  return (
    <FeaturedLayout
      title="Planes de pago"
      subtitle="Crea y gestiona planes de cobro por temporada"
    >
      <PlanesTab
        temporadaId={temporadaId}
        temporadas={temporadas}
        temporadaSelector={<TemporadaSelector temporadas={temporadas} value={temporadaId} onChange={setTemporadaId} className="w-full sm:w-auto" />}
      />
    </FeaturedLayout>
  )
}

export default PagosPlanes
